import React, { useState, useEffect } from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  useTranslate,
  useNotify,
  useRedirect,
  required,
} from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { TransferList } from 'src/components/uiElements/react-hook-fields/TransferList'
import { permissionServices } from 'src/services/auth/permission/permission.service'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { clientServices } from 'src/services/auth/client/client.service'
import { applicationServices } from 'src/services/auth/application/application.service'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'

export const RoleCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [clients, setClients] = useState([])
  const [loadingClients, setLoadingClients] = useState(false)
  const [applications, setApplications] = useState([])
  const [loadingApplications, setLoadingApplications] = useState(false)
  const [permissions, setPermissions] = useState([])
  const [loadingPermissions, setLoadingPermissions] = useState(false)

  useEffect(() => {
    ;(async () => {
      setLoadingClients(true)
      try {
        const allClients = await clientServices.getByAll()
        if (allClients) {
          setClients(allClients)
          setLoadingClients(false)
          return
        }
        notify(`applications not found`, { type: 'error' })
        setLoadingClients(false)
      } catch (error) {
        notify(`please, refresh page`, { type: 'error' })
        setLoadingClients(false)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getApplicationByClient = async (idClient) => {
    if (idClient) {
      try {
        setPermissions([])
        setLoadingApplications(true)
        let allApplications = await applicationServices.getApplicationByClient(idClient)
        setApplications(allApplications.map((item) => item.application))
        setLoadingApplications(false)
      } catch (error) {
        notify(`applications not found`, { type: 'error' })
        setLoadingApplications(false)
        return
      }
    }
  }

  const getPermissionsByApplication = async (id_application) => {
    if (id_application) {
      try {
        setLoadingPermissions(true)
        let allPermissions = await permissionServices.getPermissionsByApplications(id_application)
        if (allPermissions) {
          setPermissions(allPermissions)
          setLoadingPermissions(false)
          return
        }
        setPermissions([])
        setLoadingPermissions(false)
      } catch (error) {
        setPermissions([])
        notify(`permissions not found`, { type: 'error' })
        setLoadingPermissions(false)
        return
      }
    }
  }

  const onSuccess = () => {
    notify('ra.notification.created_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.role') }
    })
    redirect('/role')
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.role') }
    })
  }

  const transform = (data) => ({
    ...data,
    permission_id: data?.permission_id.map((perm) => perm.id),
  })

  return (
    <Create {...props} transform={transform} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_role')}>
        <SimpleForm>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4} className='uiInputLabel'>
              <EditInputsWrap label={translate('ra.field.short_name')} md={12} required>
                <TextInput label='' source='short_name' fullWidth validate={[required()]} />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.long_name')} md={12}>
                <TextInput label='' source='long_name' fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.client')} md={12} required>
                {loadingClients ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    source='client_id'
                    optionsText={['long_name']}
                    label=''
                    fullWidth
                    options={clients}
                    onChange={(e) => getApplicationByClient(e.target.value)}
                    validate={[required()]}
                  />
                )}
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.application')} md={12} required>
                {loadingApplications ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    source='application_id'
                    optionsText={['long_name']}
                    options={applications}
                    label=''
                    fullWidth
                    onChange={(e) => getPermissionsByApplication(e.target.value)}
                    validate={[required()]}
                  />
                )}
              </EditInputsWrap>
            </Grid>
            <Grid item xs={12} sm={8} className='uiInputLabel'>
              <EditInputsWrap label={'Selección'} md={12}>
                {loadingPermissions ? (
                  <Grid
                    container
                    spacing={2}
                    justifyContent='center'
                    alignItems='center'
                    className='transferListComponent'
                  >
                    <Grid item xs={5}>
                      <Skeleton variant='rectangular' width={'100%'} height={500} />
                    </Grid>
                    <Grid item xs={2}>
                      <Grid container direction='column' alignItems='center'>
                        <Skeleton variant='rectangular' width={'100%'} height={40} />
                      </Grid>
                    </Grid>
                    <Grid item xs={5}>
                      <Skeleton variant='rectangular' width={'100%'} height={500} />
                    </Grid>
                  </Grid>
                ) : (
                  <TransferList source='permission_id' options={permissions} />
                )}
              </EditInputsWrap>
            </Grid>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
